import { useNavigate } from 'react-router-dom';
import { Wrench } from 'lucide-react';
import { NavBar } from '@design-system/NavBar.tsx';
import { ACCOUNT_MANAGEMENT_PATH } from '@/constants/paths';

export const SMPMaintenancePage = () => {
  const navigate = useNavigate();

  return (
    <section
      className="page-container flex flex-col gap-6 pb-24"
      data-testid="smp-maintenance-page"
    >
      <NavBar
        data-testid="navbar"
        returnButtonTitle="Back"
        className="md:-ml-9"
        onReturnClick={() => navigate(ACCOUNT_MANAGEMENT_PATH)}
      />

      <div className="flex flex-col items-center justify-center gap-6 py-24">
        <div className="flex size-16 items-center justify-center rounded-full bg-background-maintenance">
          <Wrench className="size-8 text-white" aria-hidden="true" />
        </div>

        <div className="flex flex-col items-center gap-3 text-center">
          <h1
            className="text-[32px] md:text-[40px] font-normal text-primary"
            data-testid="smp-maintenance-title"
          >
            Scheduled Maintenance
          </h1>
          <p className="typography-body max-w-md text-secondary">
            We&apos;re performing system maintenance to improve your experience.
            Subscription management is temporarily unavailable and will be back
            within 30 minutes.
          </p>
          <p className="typography-body text-secondary">
            We apologize for any inconvenience. Please check back shortly.
          </p>
        </div>
      </div>
    </section>
  );
};
